import { Navigate, useParams } from 'react-router-dom';

/**
 * Redirects legacy path-based content performance URLs
 * (`/:networkId/content-performance/:showId?/:from?/:to?`) to the new query-param URL
 * (`/content-performance?networks=&shows=&from=&to=`).
 *
 * `showId === 'all'` (the "all shows" sentinel) maps to an omitted `shows` param.
 */
const LegacyContentPerformanceRedirect = () => {
  const { networkId, showId, from, to } = useParams();

  const searchParams = new URLSearchParams();
  if (networkId) searchParams.set('networks', networkId);
  if (showId && showId !== 'all') searchParams.set('shows', showId);
  if (from) searchParams.set('from', from);
  if (to) searchParams.set('to', to);

  const search = searchParams.toString();
  return <Navigate to={`/content-performance${search ? `?${search}` : ''}`} replace />;
};

export default LegacyContentPerformanceRedirect;
